import React from 'react';
import styled from 'styled-components';
import { urlFor } from '../../../Sanityclient';
import { AiFillEye, AiFillGithub } from 'react-icons/ai';
import { motion } from 'framer-motion';
import PropTypes from 'prop-types';
import './ProjectCard.scss';
const Card = styled.div`
  margin: 2rem;
  width: 330px;
  height: 490px;
  background-color: ${'#171721'};
  cursor: pointer;
  border-radius: 12px;
  box-shadow: 0 0 12px 4px rgba(0, 0, 0, 0.4);
  overflow: hidden;
  padding: 26px 20px;
  display: flex;
  flex-direction: column;
  gap: 14px;
  transition: all 0.5s ease-in-out;
  &:hover {
    transform: translateY(-10px);
    box-shadow: 0 0 50px 4px rgba(0, 0, 0, 0.6);
    filter: brightness(1.1);
  }
`;
const Image = styled.img`
  width: 100%;
  height: 180px;
  background-color: ${'#FFFFFF'};
  border-radius: 10px;
  box-shadow: 0 0 16px 2px rgba(0, 0, 0, 0.3);
`;
const Technologies = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 4px;
`;
const Tags = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 4px;
`;
const Tag = styled.div`
  font-size: 16px;
  font-weight: 400;
  color: ${'#FFF'};
  background-color: ${'#313bac'};
  padding: 2px 8px;
  border-radius: 10px;
`;
const Technology = styled.div`
  font-size: 12px;
  font-weight: 400;
  color: ${'#FFF'};
  background-color: ${'#313bac'};
  padding: 2px 8px;
  border-radius: 10px;
`;
const Details = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 0px;
  padding: 0px 2px;
`;
const Title = styled.div`
  font-size: 20px;
  font-weight: 600;
  color: ${'#b1b2b3'};
  overflow: hidden;
  display: -webkit-box;
  max-width: 100%;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
`;
const Title2 = styled.div`
  font-size: 16px;
  font-weight: 500;
  color: ${'#b1b2b3'};
  margin-right: 20px;
  overflow: hidden;
  display: -webkit-box;
  max-width: 100%;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
`;
const Title3 = styled.div`
  font-size: 16px;
  font-weight: 500;
  color: ${'#b1b2b3'};
  overflow: hidden;
  display: -webkit-box;
  max-width: 100%;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
`;
const Date = styled.div`
  font-size: 12px;
  margin-left: 2px;
  font-weight: 400;
  color: ${'#b1b2b3' + 80};
  @media only screen and (max-width: 768px) {
    font-size: 10px;
  }
`;
const Description = styled.div`
  font-weight: 400;
  color: ${'#b1b2b3' + 99};
  overflow: hidden;
  margin-top: 8px;
  display: -webkit-box;
  max-width: 100%;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  text-overflow: ellipsis;
`;
const Members = styled.div`
  display: flex;
  align-items: center;
`;
const Avatar = styled.img`
  width: 38px;
  height: 38px;
  border-radius: 50%;
  margin-left: -10px;
  background-color:${'#FFFFFF'}; };
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
  border: 3px solid ${'#171721'};
`;

const ProjectCard = ({ work }) => {
  return (
    <Card>
      <div className="app__work-img app__flex">
        <Image
          src={urlFor(work.imgUrl).url()}
          alt={work.name}
          className="image_element"
        />
        <motion.div
          whileHover={{ opacity: [0, 1] }}
          transition={{
            duration: 0.25,
            ease: 'easeInOut',
            staggerChildren: 0.5,
          }}
          className="app__work-hover app__flex"
        >
          <a href={work.projectLink} target="_blank" rel="noreferrer">
            <motion.div
              whileInView={{ scale: [1] }}
              whileHover={{ scale: [0.8] }}
              transition={{ duration: 1, type: 'tween' }}
              className="app__flex"
            >
              <AiFillEye />
            </motion.div>
          </a>
          <a href={work.codeLink} target="_blank" rel="noreferrer">
            <motion.div
              whileInView={{ scale: [1] }}
              whileHover={{ scale: [0.8] }}
              transition={{ duration: 1, type: 'tween' }}
              className="app__flex"
            >
              <AiFillGithub />
            </motion.div>
          </a>
        </motion.div>
      </div>
      <Technologies>
        {work?.technology.map((technology, index) => (
          <Technology key={index}>{technology}</Technology>
        ))}
      </Technologies>
      <Details>
        <Title>{work.title}</Title>
        <Date>{work.date}</Date>
        <Description>{work.description}</Description>
      </Details>
      <Members>
        <Title2>Members :</Title2>
        {work.members?.map((member) => (
          <Avatar
            key={member.name} // Use a unique identifier for the key
            src={urlFor(member.imgUrl).url()}
            alt={member.name}
          />
        ))}
      </Members>
      <Tags>
        <Title3>Tag(s) :</Title3>
        {work?.tags.map((tags, index) => (
          <Tag key={index}>{tags}</Tag>
        ))}
      </Tags>
    </Card>
  );
};

ProjectCard.propTypes = {
  work: PropTypes.shape({
    imgUrl: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    projectLink: PropTypes.string.isRequired,
    codeLink: PropTypes.string.isRequired,
    technology: PropTypes.arrayOf(PropTypes.string).isRequired,
    title: PropTypes.string.isRequired,
    date: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    members: PropTypes.arrayOf(
      PropTypes.shape({
        imgUrl: PropTypes.string.isRequired,
        name: PropTypes.string.isRequired,
      }),
    ),
    tags: PropTypes.arrayOf(PropTypes.string).isRequired,
  }).isRequired,
};

export default ProjectCard;
